import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useMemo , useRef } from "react";
import {
  SetTheSiteTransferActions,
  setTheoptions,
  setThecountBasedRenders,
  ////--filters
  setRegionActions,
  setZoneActions,
  setGeoLoactionStateAction,
  getSideBarfilesActions,
  setTheStatusFilter,
  setDropDownRenders,
  setTheSiteTransferState,
  setTheSiteTransferRegion,
  setTheSiteTransferZone,
  setheSiteTransferdesignationStatus,
  setTheSiteTransferStateStatus,
  setTheSiteTransferRange1,
  setTheSiteTransferRange2,
  setTheSiteTransferDetailsExportActions,// exports
  setTablePositionPersist
} from "../../../Redux/Slice";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import Select from "react-select";
import { NavLink } from "react-router-dom";
import ReactTable from "../../AppComponent/Table";
import SiteTransferApprove from "./SiteTransferApprove";
import SiteCreateEdit from "./SiteCreateEdit";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";

import { differenceInDays } from "date-fns";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import _ from "lodash";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import useDebouncedEffect from "use-debounced-effect";
import dayjs from "dayjs";

const SiteTransfer = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const dateRangeRef = useRef(null);
  
   const state = useSelector((state) => state);
  const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist
  )
  const UserObjectData = useSelector((state) => state.users.UserData);

const [dtpageindex, setdtPageindex] = useState(
    TablePositionPersist?.SitetransferlistRequestedPagelist?.page == undefined
      ? 1
      : TablePositionPersist.SitetransferlistRequestedPagelist.page
  ); 
  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [newpages, setNewpage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

const [search, setsearch] = useState(
    TablePositionPersist?.SitetransferlistRequestedPagelist?.search == undefined ||
    TablePositionPersist?.SitetransferlistRequestedPagelist?.search ==""
      ? ""
      : TablePositionPersist.SitetransferlistRequestedPagelist.search
  ); 
   
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [EmployeePop, setEmployeePop] = useState(false);
  const [EmployeeIDs, setEmployeeIDs] = useState();
  const [createpoup, setcreatepoup] = useState(false);

  ///---filter for white collar--------
  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "",
      label: "ALL",
    },
    {
      value: "1",
      label: "QPMS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);
  const [sno, setsno] = useState(0);

  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(state.StateManagementOverallCall.Site_TransferRange1);
  var gt = convert(state.StateManagementOverallCall.Site_TransferRange2);
             const today_day = dayjs().format("YYYY-MM-DD");
  
  const [range, setrange] = useState(
    state.StateManagementOverallCall.Site_TransferRange1 == ""
        ? [today_day ,today_day] 

      : [it, gt]
  );

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  //----Handle----Date=-----Changes---
  const handlechangedate = (value) => {
    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };

  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      dispatch(setTheSiteTransferRange1(range[0]));
      dispatch(setTheSiteTransferRange2(range[1]));
    }
                if(state.StateManagementOverallCall.Site_TransferRange1 == ""){
                  dispatch(setTheSiteTransferRange1(today_day));
                  dispatch(setTheSiteTransferRange2(today_day));
                }
  }, [range]);

  useEffect(() => {
    dispatch(setDropDownRenders(""));
    //  if(state.ClientBranchIDs.DashboardIDs == 3  ){
    if (state.NumberCounts.namerednder == "") {
      dispatch(setTheoptions(options[0]));
      SetPlace("All");
      SetSelectval({
        ///Completed
        ...selectVal,
        is_pending: "",
        is_decline: "",
        approved: "",
      });
      const StatusFilter = { is_pending: "", is_decline: "", approved: "" };

      dispatch(setTheStatusFilter(StatusFilter));
    }
    if (state.NumberCounts.namerednder == "completed") {
      dispatch(setTheoptions(options[1]));
      SetPlace("Approved");

      SetSelectval({
        ///Completed
        ...selectVal,
        // is_pending: false,
        // is_decline: false,
        // approved: "",
        is_pending: "",
        is_decline: "",
        approved: true,
      });

      const StatusFilter = { is_pending: "", is_decline: "", approved: true };

      dispatch(setTheStatusFilter(StatusFilter));
    }
    if (state.NumberCounts.namerednder == "Decline") {
      dispatch(setTheoptions(options[3]));
      SetPlace("Decline");

      SetSelectval({
        ...selectVal,
        is_decline: true,
        is_pending: "",
        approved: "",
      });

      const StatusFilter = { is_pending: "", is_decline: true, approved: "" };

      dispatch(setTheStatusFilter(StatusFilter));
    }
    if (state.NumberCounts.namerednder == "Pending") {
      dispatch(setTheoptions(options[2]));
      SetPlace("Pending");
      SetSelectval({
        ...selectVal,
        is_pending: true,
        is_decline: "",
        approved: "",
      });

      const StatusFilter = { is_pending: true, is_decline: "", approved: "" };

      dispatch(setTheStatusFilter(StatusFilter));
    }
    // }
  }, [state.NumberCounts.namerednder]);

  const [filterForWhite, setFilters] = useState({
    white_collar: false,

    // state.StateManagementOverallCall.Site_Transferdesignation?.value == ""?
    // "":
    // state.StateManagementOverallCall.Site_Transferdesignation?.value == 1 ?
    // true:
    // false
  });
  const HandleEMprole = (e) => {
    setdtPageindex(1);

    if (e != null) {
      dispatch(setheSiteTransferdesignationStatus(e));
      if (e.value == 1) {
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });
      } else if (e.value == 2) {
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
      } else if (e.value == "") {
        setFilters({
          ...filterForWhite,
          white_collar: "",
        });
        dispatch(
          setheSiteTransferdesignationStatus({ value: "", label: "ALL" })
        );
      }
    }
  };

  const FileterState = {
    status: state.StateManagementOverallCall.Site_TransferStatusState?.value,
  };
  const [selectDisplay, setDisplay] = useState([]);
  const [selectVal, SetSelectval] = useState(FileterState);
  const [FState, SetStates] = useState(false);

  ////--_FIlter--------------------------
  const [Filter, SetFilter] = useState(true);
  /// console.log(state.NumberCounts, "fsdf");
  const options = [
    { value: state.NumberCounts.Option1, label: "All" },
    { value: state.NumberCounts.Option3, label: "Pending" },
    { value: state.NumberCounts.Option4, label: "Decline" },
    { value: state.NumberCounts.Option5, label: "Approved" },
  ];
  const [place, SetPlace] = useState("");
  const [sel, setSelected] = useState();
  ///--filter----------------
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState(
    state.StateManagementOverallCall.Site_TransferRegion
  );
  const [multiselect3, setMuliselect3] = useState(
    state.StateManagementOverallCall.Site_TransferZone
  );
  const [nameList4, setOptions4] = useState([]);
  const [Zone, setZone] = useState([]);
  const [data, setData] = useState({
    zone: state.StateManagementOverallCall.Site_TransferZone?.value,
    state: state.StateManagementOverallCall.Site_TransferState?.value,
    region: state.StateManagementOverallCall.Site_TransferRegion?.value,
  });
  const [multiselect, setMuliselect] = useState(
    state.StateManagementOverallCall.Site_TransferState
  );
  //--------Place---Holder----dispatch======
  useEffect(() => {
    if (state.NumberCounts.namerednder == "") {
      dispatch(setTheoptions(options));
      SetPlace("All");
    }
    if (state.NumberCounts.namerednder == "completed") {
      dispatch(setTheoptions(options[0]));
      SetPlace("Completed");
    }
    if (state.NumberCounts.namerednder == "Decline") {
      dispatch(setTheoptions(options[3]));
      SetPlace("Decline");
    }
    if (state.NumberCounts.namerednder == "Pending") {
      dispatch(setTheoptions(options[2]));
      SetPlace("Pending");
    }
  }, [state.NumberCounts.namerednder]);

  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      const payload = {
        search: search,
        page_size: 20,
        page: dtpageindex,
        from_client: state.ClientBranchIDs.SingelEmployeelistes,
        selectVal: selectVal,
        data: data,
        user: state.ClientBranchIDs.EmployeeDetailsProfile,
        // white_collar: filterForWhite.white_collar,
        // month: Datestate.month,
        // year: Datestate.year,
        // date:Datestate.date ,

        from_date: range[0],

        to_date: range[1],
      };
      //      if (
      //   state.SiteTransfertLists.SiteTranfersdataList.length == 0 ||
      //   TablePositionPersist?.SitetransferlistRequestedPagelist?.page != dtpageindex ||
      //   TablePositionPersist?.SitetransferlistRequestedPagelist?.search != search ||
      //   TablePositionPersist?.SitetransferlistRequestedPagelist?.selectVal.status != selectVal.status ||
      //   TablePositionPersist?.SitetransferlistRequestedPagelist?.from_date != range[0] ||
      //   TablePositionPersist?.SitetransferlistRequestedPagelist?.to_date != range[1] ||
      //   // TablePositionPersist?.SitetransferlistRequestedPagelist?.white_collar !== filterForWhite.white_collar ||
      //   TablePositionPersist?.SitetransferlistRequestedPagelist?.data?.state != data.state ||
      //   TablePositionPersist?.SitetransferlistRequestedPagelist?.data?.region != data.region ||
      //   TablePositionPersist?.SitetransferlistRequestedPagelist?.data?.zone != data.zone ||
      //   TablePositionPersist?.SitetransferlistRequestedPagelist?.isApproved 
      // ) {
     

      dispatch(SetTheSiteTransferActions(payload));


           dispatch(
              setTablePositionPersist({
                data: payload,
                pageName: "SitetransferlistRequestedPagelist",
              })
            );
          }
    // }
          currentRef.current.scrollTop = sessionStorage.getItem(
      "SitetransferlistrequestScrollpages"
    );

  }, [
    selectVal,
    data,
    state.ClientBranchIDs.EmployeeDetailsProfile,
    filterForWhite,
    range,
    dtpageindex,
    search,
  ]);

  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage);
  };

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
    }
  };
  ///----filter-----
  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };

  const [SearchDebounance, setSearchDebounance] = useState(
    initialDebouanceSearch
  );

  // ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);
  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: currentPage,
      counts: 1,
      region_id: data.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [data.region, SearchedVal.zoneSearch]);
  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: currentPage,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Cou
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);
  useEffect(() => {
    const Datas = [];
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.GeoState.State.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.state_name.toUpperCase(),
        });
      });
      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];
    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name.toUpperCase(),
        });
      });
      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      dispatch(setTheSiteTransferRegion(selectedVal));
      dispatch(setTheSiteTransferZone({ value: "", label: "ALL" }));

      setData({
        ...data,
        region: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setTheSiteTransferRegion({ value: "", label: "ALL" }));
      dispatch(setTheSiteTransferZone({ value: "", label: "ALL" }));

      setData({
        ...data,
        region: "",
        zone: "",
      });
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      dispatch(setTheSiteTransferZone(selectedVal));

      setData({
        ...data,
        zone: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setData({
        ...data,
        zone: "",
      });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setTheSiteTransferState(selectedVal));
      dispatch(setTheSiteTransferZone({ value: "", label: "ALL" }));
    }
  };
  const handleSelectChange = (selectedVal) => {
    console.log(selectedVal, "selectedval");
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      dispatch(setTheSiteTransferState(selectedVal));
      dispatch(setTheSiteTransferRegion({ value: "", label: "ALL" }));
      dispatch(setTheSiteTransferZone({ value: "", label: "ALL" }));

      setData({
        ...data,
        region: "",
        zone: "",
        state: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      dispatch(setTheSiteTransferState({ value: "", label: "ALL" }));
      dispatch(setTheSiteTransferRegion({ value: "", label: "ALL" }));
      dispatch(setTheSiteTransferZone({ value: "", label: "ALL" }));

      setData({
        ...data,
        state: "",
        zone: "",
        region: "",
      });
    }
  };
  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];
    setZone(state.ZonePart.Zone);
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.zone_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

  ///-----State----Input Changes
  const handleInputChange = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      stateSearch: Val,
    });
  };

  ///---Region-----------------
  const handleInputRegion = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      regionSearch: Val,
    });
  };
  ///----Zone---Name
  const handleInputZone = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      zoneSearch: Val,
    });
  };

  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearched({
          ...SearchedVal,
          stateSearch: SearchDebounance.stateSearch,
          regionSearch: SearchDebounance.regionSearch,
          zoneSearch: SearchDebounance.zoneSearch,
        });
      }
    },
    500,
    [SearchDebounance]
  );


  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };

  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);
  }
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    []
  );
  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };
  const truncateText = (text, maxLength = 10) => {
    if (!text) return "";
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };

  const columns = useMemo(
    () => [
      {
        Header: "Tnx Id",
        accessor: "",
        Cell: (row) => {
          if (
            row.row.original.id != undefined &&
            row.row.original.id != null
          ) {
            const userId = row.row.original.id;
            const lastFourDigits = userId.slice(-6);
            return <p className="m-0">{lastFourDigits}</p>;
          }
        },
      },
      // {
      //   Header: "U-ID",
      //   accessor: "user_id.local_uid",
      //   Cell: ({ row }) => {
      //     const userId = row.original?.user_id?.local_uid;

      //     // Handle null, undefined, empty string, or whitespace
      //     const displayValue =
      //       userId == null || String(userId).trim() == "" ? "--" : userId;

      //     return <p className="PTAGs">{displayValue}</p>;
      //   },
      // },
  {
      Header: "Employee Code",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              className="UserName"
              style={{ cursor: "pointer" }}
            >
              <div className="">
                <span>
                  {row.row.original.user_id?.user_uid != null &&
                  row.row.original.user_id?.user_uid != undefined &&
                  row.row.original.user_id?.user_uid != ""
                    ? row.row.original.user_id?.user_uid
                    : "--"}
                </span>
              </div>
            </div>
          </>
        );
      },
    },
      {
        Header: filterForWhite.white_collar ? "User Name" : "Employee Name",
        accessor: "",
        Cell: (row) => {
           const [showTooltip, setShowTooltip] = useState(false);
          const text = row.row.original.user_id.first_name;
          return (
            <>
              {row.row.original.user_id.first_name ? (
                <div
                   onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                    style={{ position: "relative" }} // Ensure the tooltip is positioned correctly

                >
                <span>
               {truncateText(text, 20)}
                  </span>

                {showTooltip && (
                    <div className="custom-tooltip">
                      {row.row.original.user_id.first_name}
                    </div>
                  )}
                </div>
              ) : (
                <span>---</span>
              )}
            </>
          );
        },
      },
      {
        Header: "Role",
        accessor: "",
        Cell: (row) => {
          const [showTooltip, setShowTooltip] = useState(false);
const text = row.row.original.user_id.user_role?.role;
          return (
            <>
              {row.row.original.user_id.user_role != null &&
              row.row.original.user_id.user_role != undefined ? (
                <div>
                  {" "}
                  <span
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                    style={{ position: "relative" }} // Ensure the tooltip is positioned correctly
                  >
                    {truncateText(text, 20)}
                  </span>
                  {showTooltip && (
                    <div className="custom-tooltip">
                      {row.row.original.user_id.user_role?.role}
                    </div>
                  )}
                </div>
              ) : (
                <span>---</span>
              )}
            </>
          );
        },
      },

      {
        Header: "Created Date",
        accessor: "",
        Cell: (row) => {
          const dateString = row.row.original.created_at;
          const dateObject = new Date(dateString);
          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12;

          const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

          const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

          return (
            <>
              <span>
                {`${
                  row.row.original.created_at.slice(0, 10) +
                  "  " +
                  formattedTime
                }`}
              </span>
            </>
          );
        },
      },

//       {
//         Header: "From Branch",
//         accessor: "",
//         Cell: (row) => {
//           const [showTooltip, setShowTooltip] = useState(false);
// const text = row.row.original.from_client.client_name;

//           return (
//             <>
//               <div>
//                 {row.row.original.from_client != null &&
//                 row.row.original.from_client != undefined &&
//                 row.row.original.from_client.client_name != null ? (
//                   <div>
//                     <span
//                       onMouseEnter={() => setShowTooltip(true)}
//                       onMouseLeave={() => setShowTooltip(false)}
//                       style={{ position: "relative" }} // Ensure the tooltip is positioned correctly
//                     >
//                       {truncateText(
//                         text,
//                         20
//                       )}
//                     </span>

//                     {showTooltip && (
//                       <div className="custom-tooltip">
//                         {row.row.original.from_client.client_name}
//                       </div>
//                     )}
//                   </div>
//                 ) : (
//                   <span>---</span>
//                 )}
//               </div>
//             </>
//           );
//         },
//       },
{
  Header: "From Branch",
  accessor: "",
  Cell: (row) => {
    const [showTooltip, setShowTooltip] = useState(false);

    const client = row?.row?.original?.from_client;
    const branchCode = client?.branch_code ?? "";
    const clientName = client?.client_name ?? "";

    // Full label for tooltip
    const fullLabel = branchCode
      ? `${branchCode} - ${clientName}`
      : clientName;

    // Short display (truncate client name only)
    const shortName =
      clientName.length > 12 ? `${clientName.slice(0, 12)}...` : clientName;

    const shortLabel = branchCode
      ? `${branchCode} - ${shortName}`
      : shortName;

    return (
      <>
        {client && clientName ? (
          <div
            className="UserName"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            style={{ position: "relative" }}
          >
            <span>{shortLabel}</span>

            {showTooltip && (
              <div className="custom-tooltip">{fullLabel}</div>
            )}
          </div>
        ) : (
          <div className="UserName">
            <span>---</span>
          </div>
        )}
      </>
    );
  },
},
//       {
//         Header: "To Branch",
//         accessor: "",
//         Cell: (row) => {
//           const [showTooltip, setShowTooltip] = useState(false);
// const text = row.row.original.to_client.client_name;

//           return (
//             <>
//               {row.row.original.to_client != null &&
//               row.row.original.to_client != undefined &&
//               row.row.original.to_client.client_name != null ? (
//                 <div>
//                   <span
//                     onMouseEnter={() => setShowTooltip(true)}
//                     onMouseLeave={() => setShowTooltip(false)}
//                     style={{ position: "relative" }} // Ensure the tooltip is positioned correctly
//                   >
//                     {truncateText(text, 20)}
//                   </span>

//                   {showTooltip && (
//                     <div className="custom-tooltip">
//                       {row.row.original.to_client.client_name}
//                     </div>
//                   )}
//                 </div>
//               ) : (
//                 <span>---</span>
//               )}
//             </>
//           );
//         },
//       },

 {
  Header: "To Branch",
  accessor: "",
  Cell: (row) => {
    const [showTooltip, setShowTooltip] = useState(false);

    const client = row?.row?.original?.to_client;
    const branchCode = client?.branch_code ?? "";
    const clientName = client?.client_name ?? "";

    // Full label for tooltip
    const fullLabel = branchCode
      ? `${branchCode} - ${clientName}`
      : clientName;

    // Short display (truncate client name only)
    const shortName =
      clientName.length > 12 ? `${clientName.slice(0, 12)}...` : clientName;

    const shortLabel = branchCode
      ? `${branchCode} - ${shortName}`
      : shortName;

    return (
      <>
        {client && clientName ? (
          <div
            className="UserName"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            style={{ position: "relative" }}
          >
            <span>{shortLabel}</span>

            {showTooltip && (
              <div className="custom-tooltip">{fullLabel}</div>
            )}
          </div>
        ) : (
          <div className="UserName">
            <span>---</span>
          </div>
        )}
      </>
    );
  },
},

      {
        Header: "Status",
        accessor: "status",
        Cell: (row) => {
          const originalString = row.row.original.status;
          const capitalizedString = capitalizeFirstLetter(originalString);
          return (
            <>
              {row.row.original.status != undefined ? (
                <>
                  {row.row.original.status.toLowerCase() == "pending" ? (
                    <div className="StatusList">
                      <img src={Pendingimg} />
                      <span>{capitalizedString}</span>
                    </div>
                  ) : (
                    <>
                      {row.row.original.status.toLowerCase() == "decline" ? (
                        <div className="StatusList">
                          <div className="DeclineStatus">
                            <span>x</span>
                          </div>
                          <span>{capitalizedString}</span>
                        </div>
                      ) : (
                        <>
                          {row.row.original.status.toLowerCase() ==
                          "approved" ? (
                            <div className="StatusList">
                              <img src={correctIcons} />
                              <span>{capitalizedString}</span>
                            </div>
                          ) : null}
                        </>
                      )}
                    </>
                  )}
                </>
              ) : (
                <span>---</span>
              )}
            </>
          );
        },
      },

      {
        Header: "Action",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div
                class="actions"
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: "5px",
                  // cursor:
                  //   row.row.original.status.toLowerCase() == "approved"
                  //     ? "not-allowed"
                  //     : "",
                }}
              >
                <button
                  className=" btn Status"
                  component="span"
                  disabled={row.row.original.status.toLowerCase() != "approved" && 
                  row.row.original.status.toLowerCase() != "decline" ? false :true}
                  onClick={(e) => {
                    if (row.row.original.status.toLowerCase() != "approved" && 
                  row.row.original.status.toLowerCase() != "decline") {
                      setEmployeePop(true);
                      setEmployeeIDs(row.row.original.id);
                    }
                  }}
                >
                  <span className="OuterActionSpan">
                    <span className="EditImages">
                      <img src={EditImages} />
                    </span>
                    <span className="ActionsList"> Approve </span>
                  </span>
                </button>
              </div>
            </>
          );
        },
      },
    ],
    [sno]
  );
  const ClearState = (Counts) => {
    if (Counts == 2) {
      SetSelectval({
        ...selectVal,

        status: "",
      });
      setdtPageindex(1);
      dispatch(setTheSiteTransferStateStatus({ value: "", label: "ALL" }));
    }
  };

  //--------_____Filter-----------Based---On----Status--
  const count = (Counts, values, sel, SelectedValues) => {
    console.log(Counts, values, sel, "Logs");
    //console.log(SelectedValues, "selectedvaluess");
    setDisplay(SelectedValues);
    setdtPageindex(1);

    setSelected(sel);
    SetStates(true);
    dispatch(setTheSiteTransferStateStatus(SelectedValues));

    if (values == "Completed") {
      SetSelectval({
        ///Completed
        ...selectVal,

        status: "completed",
      });
    } else if (values == "Pending") {
      ///Pending
      SetSelectval({
        ...selectVal,

        status: "pending",
      });
    } else if (values == "Decline") {
      //Decline
      SetSelectval({
        ...selectVal,
        is_decline: true,
        is_pending: "",
        approved: "",
        status: "decline",
      });
    } else if (values == "Approved") {
      //Approve
      SetSelectval({
        ...selectVal,

        status: "approved",
      });
    } else if (values == "ALL") {
      //Approve
      SetSelectval({
        ...selectVal,

        status: "",
      });
    }
     else if (values == "All") {
      //Approve
      SetSelectval({
        ...selectVal,

        status: "",
      });
    }
  };

  const cleaningrange = () => {
    //setrange([gt,it]);
  };

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
  ];

  const openMe = () => {
    const rsAnimFade = document.querySelector(".rs-anim-fade");
    if (rsAnimFade) {
      rsAnimFade.style.setProperty("left", "1071.344px", "important");
      rsAnimFade.style.setProperty("top", "184.109px", "important");
    }
  };

  const CloseDateRange = () => {
    const rsAnimFade = document.querySelector(".rs-anim-fade");
    if (rsAnimFade) {
      rsAnimFade.style.setProperty("display", "none", "important");
      // rsAnimFade.style.setProperty('top', '184.109px', 'important');
    }
  };


      const currentRef = useRef();
    const scrollPosition = (e) => {
      const val = currentRef.current.scrollTop; 
      sessionStorage.setItem("SitetransferlistrequestScrollpages", val);
    };
  

    const getZoomFactor = () => {
  const zoom = document.body.style.zoom;
  return zoom ? parseFloat(zoom) / 100 : 1;
};

const alignDateRangePicker = (pickerNode) => {
  const picker =
    pickerNode?.root || pickerNode?.container || pickerNode;

  const popup = document.querySelector(
    ".rs-picker-popup.rs-picker-popup-daterange"
  );

  if (!picker || !popup) return;

  const zoom = getZoomFactor();
  const rect = picker.getBoundingClientRect();

  const popupWidth = popup.offsetWidth;
  const popupHeight = popup.offsetHeight;

  const viewportWidth = window.innerWidth / zoom;
  const viewportHeight = window.innerHeight / zoom;

  const scrollX = window.scrollX / zoom;
  const scrollY = window.scrollY / zoom;

  let left = rect.right / zoom - popupWidth + scrollX;
  let top = rect.bottom / zoom + 8 + scrollY;

  if (left < 8) left = 8;
  if (left + popupWidth > viewportWidth - 8) {
    left = viewportWidth - popupWidth - 8;
  }

  if (top + popupHeight > viewportHeight + scrollY - 8) {
    top = rect.top / zoom - popupHeight - 8 + scrollY;
  }

  popup.style.position = "absolute";
  popup.style.left = `${left}px`;
  popup.style.top = `${top}px`;
};

  return (
    <>
      <div 
      
                          onScroll={scrollPosition}
        ref={currentRef}

      className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Site Transfer</h3>
          </div>
        </div>

        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "90",

            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              State
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                setdtPageindex(1);
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              value={multiselect}
              placeholder={"Search"}
            />
          </div>
          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              Region
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                setdtPageindex(1);

                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={
                multiselect1
                  ? Array.isArray(multiselect1)
                    ? multiselect1.some(
                        (item) => item.label === "ALL" || item.label === "All"
                      )
                      ? false
                      : true
                    : multiselect1.label === "ALL" ||
                      multiselect1.label === "All"
                    ? false
                    : true
                  : true
              }
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
              // placeholder={
              //   data.state == ""
              //     ? "without selected state you can't select Region"
              //     : "search"
              // }
            />
          </div>
          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              Zone
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                setdtPageindex(1);
                handleZone(e);
              }}
              options={nameList4}
              isClearable={
                multiselect3
                  ? Array.isArray(multiselect3)
                    ? multiselect3.some(
                        (item) => item.label === "ALL" || item.label === "All"
                      )
                      ? false
                      : true
                    : multiselect3.label === "ALL" ||
                      multiselect3.label === "All"
                    ? false
                    : true
                  : true
              }
              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              value={multiselect3}
              onInputChange={handleInputZone}
              // placeholder={
              //   data.state == ""
              //     ? "without selected state you can't select Zone"
              //     : data.region == ""
              //     ? "without selected Region you can't select Zone"
              //     : "Search"
              // }
            />
          </div>

          <div className="col-sm-2">
            <label
              for="validationCustom01"
              class="form-label"
              style={{ marginBottom: "11px" }}
            >
              {/* State Name */}
              Select Date
              <span style={{ color: "red" }}>*</span>
            </label>

            <div className="datepicker_dash" style={{ marginTop: "-5px" }}>
              <DateRangePicker
                defaultValue={
                  state.StateManagementOverallCall.Site_TransferRange1 == ""
                    ? [new Date(range[0]), new Date(range[1])]
                    : [
                        new Date(
                          state.StateManagementOverallCall.Site_TransferRange1
                        ),
                        new Date(
                          state.StateManagementOverallCall.Site_TransferRange2
                        ),
                      ]
                }
                                                ref={dateRangeRef}

          onOpen={() => {
            
    setTimeout(() => {
      alignDateRangePicker(dateRangeRef.current);
    }, 80);
  }}


  style={{
    width: "100%",
    padding: "0px 5px",
  }}
                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                // style={{ width: 270, padding: 10 }}
                onClean={(e) => cleaningrange(e)}
                onChange={(e) => {
                  if (e != null && e.length === 2) {
                    const [startDate, endDate] = e;
                    const diffDays = differenceInDays(endDate, startDate);
                    // if (diffDays === 30) {
                    //   // Since we are using inclusive range, difference should be 30 for 31 days
                    //   setrange([]);
                    //   e.forEach((newValue) => {
                    //     const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                    //     const localISOTime = new Date(newValue - tzoffset)
                    //       .toISOString()
                    //       .slice(0, -1);
                    //     handlechangedate(localISOTime);
                    //   });
                    // } else if (diffDays < 30) {
                    //   setrange([]);
                    //   e.forEach((newValue) => {
                    //     const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                    //     const localISOTime = new Date(newValue - tzoffset)
                    //       .toISOString()
                    //       .slice(0, -1);
                    //     handlechangedate(localISOTime);
                    //   });
                    // } else {
                    //   toast.error("Please select a range of exactly 31 days.", {
                    //     position: toast.POSITION.TOP_RIGHT,
                    //   });
                    // }
                    setrange([]);
                    e.forEach((newValue) => {
                      const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                      const localISOTime = new Date(newValue - tzoffset)
                        .toISOString()
                        .slice(0, -1);
                      handlechangedate(localISOTime);
                    });
                  }
                }}
              />
            </div>
          </div>
          
                    <div className="col-sm-2" style={{ paddingTop: "18px" }}>
                      <button
                        align="center"
                        type="button"
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          background: "transparent",
                        }}
                        className="DownloadBTNS"
                        onClick={(e) => {

                            const payload  ={
        state: data?.state,
        region: data?.region,
        zone:data?.zone,
range:true,
        from_date: range[0],

        to_date: range[1],
        selectVal: selectVal?.status,
                            }
                            dispatch(setTheSiteTransferDetailsExportActions(payload))
                          
                        }}
                      >
                        <a class="dnbtn"></a>
                      </button>
                    </div>

        </div>

        <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
          <ReactTable
            data={state.SiteTransfertLists.SiteTranfersdataList}
            columns={columns}
            totalItems={state.SiteTransfertLists.Total_Count}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            datacount={state.SiteTransfertLists.Total_Count}
            values={state.StateManagementOverallCall.Site_TransferStatusState}
            options={options}
            Filter={Filter}
            ApproveRequestFilter={true}
            count={count}
            ClearState={ClearState}
            placeHold={place}
            ///--- emoloyee role based filters -
            // EmployeeRoleTrue={true}
            // EmployeeRoleOption={EmpRoles}
            // EMpROleSelected={state.StateManagementOverallCall.Site_Transferdesignation}
            // HandleEMprole={HandleEMprole}
            setsno={setsno}
            sno={sno}
            id={"spe"}
                         searchVal={TablePositionPersist?.SitetransferlistRequestedPagelist?.search == "" || TablePositionPersist?.SitetransferlistRequestedPagelist?.search ==undefined? "":TablePositionPersist.SitetransferlistRequestedPagelist.search}
              search_key={true}

          />
        </div>
      </div>

      {EmployeePop && EmployeeIDs != undefined ? (
        <SiteTransferApprove
          show={EmployeeIDs}
          setShow={setEmployeePop}
          currentPage={dtpageindex}
          data={data}
          EditId={EmployeeIDs}
          selectVal={selectVal}
          // Datestate={Datestate}
          from_dates={range[0]}
          to_dates={range[1]}
          white_collar={filterForWhite.white_collar}
          search={search}
        />
      ) : null}

      {createpoup ? (
        <SiteCreateEdit
          show={createpoup}
          setShow={setcreatepoup}
          currentPage={dtpageindex}
          EditId={EmployeeIDs}
          selectVal={selectVal}
          datas={data}
        />
      ) : null}
    </>
  );
};

export default SiteTransfer;
